import { Collapse } from 'antd';
import React from 'react';
import { Trans } from 'react-i18next';
import classnames from 'classnames';
import { getDirection } from '../../../../../helpers';
import s from './Collapsable.module.scss';
const { Panel } = Collapse;
const Collapsable = ({ title, icon, routes, goToAppPath }) => {
    const onLinkClick = (link) => {
        var _a, _b;
        if (link.url) {
            window.open(link.url, (_a = link.target) !== null && _a !== void 0 ? _a : '_blank', typeof link.windowFeatures === 'boolean'
                ? undefined
                : (_b = link.windowFeatures) !== null && _b !== void 0 ? _b : 'noopener noreferrer');
        }
        else if (link.path) {
            goToAppPath === null || goToAppPath === void 0 ? void 0 : goToAppPath(link.path);
        }
        else if (link.onClick) {
            link.onClick();
        }
    };
    return (React.createElement("div", { className: classnames(s.wrapper, { [s.rtl]: getDirection() === 'rtl' }) },
        React.createElement(Collapse, { expandIconPosition: "end", bordered: false },
            React.createElement(Panel, { header: React.createElement("div", { className: s.panelHeader },
                    React.createElement("div", { className: s.panelIcon }, icon),
                    React.createElement("span", { className: s.panelTitle },
                        React.createElement(Trans, { i18nKey: title }))), key: "1" },
                React.createElement("div", { className: s.content }, routes.map((link, index) => (React.createElement("button", { key: index, className: s.linkButton, onClick: () => onLinkClick(link), disabled: link.disabled },
                    React.createElement("div", { className: s.title },
                        link.icon,
                        React.createElement(Trans, { i18nKey: link.titleKey }))))))))));
};
export default Collapsable;
